// extracted by mini-css-extract-plugin
export var headerCell = "_44-1";
export var loadingSpinnerContainer = "_44-4";
export var rowWrapper = "_44-3";
export var standaloneTable = "_44-5";
export var table = "_44-0";
export var white = "_44-2";